import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, ButtonGroup } from "shards-react";
import SmallStats from "./../components/common/SmallStats";
import PageTitle from "./../components/common/PageTitle";
import axios from "axios";

const BlogOverview = () => {
  const [data, setData] = useState([]);
  const [project, setProject] = useState(false);
  const [platForm, setPlatForm] = useState(false);
  const [metaData, setMetaData] = useState(false);

  const base_url = "https://back.clubside.tacverse.com/api";
  // const base_url = "http://localhost:8000/api";

  useEffect(() => {
    axios.get(`${base_url}/meta`).then((res) => {
      setData(res.data);
      setPlatForm(Object.keys(res.data[0].data)[0]);
      setProject(res.data[0]);
      setMetaData(res.data[0].data[Object.keys(res.data[0].data)[0]]);
    });
  }, []);

  const handleClick = (name) => {
    const project = data.filter((item) => item.name === name)[0];
    setProject(project);
    setMetaData(
      data.filter((item) => item.name === project.name)[0].data[platForm]
    );
  };

  const handleClickPlatForm = (name) => {
    setPlatForm(name);
    setMetaData(
      data.filter((item) => item.name === project.name)[0].data[name]
    );
  };


  function capitalizeTitle(title) {
    return title.replace(/(?:^|\_)(\w)/g, function (char) {
      return char.toUpperCase();
    }).replace(/_/g, ' ').toUpperCase();;
  }


  return (
    <Container fluid className="main-content-container px-4">
      {project ? (
        <>
          <Row noGutters className="page-header py-4">
            <h6>PROJECT:</h6>
            <ButtonGroup className={"mb-4 d-flex"}>
              {data.map((item) => {
                return (
                  <Button
                    onClick={() => handleClick(item.name)}
                    outline={project.name === item.name ? false : true}
                    size="lg"
                    style={{
                      color: project.name === item.name ? "white" : "#A21C1C",
                      backgroundColor:
                        project.name === item.name ? "#A21C1C" : "",
                      borderColor: "#A21C1C",
                    }}
                  >
                    {item.name}
                  </Button>
                );
              })}
            </ButtonGroup>
            <h6>PLATFORM:</h6>
            <ButtonGroup className={"mb-4 d-flex"}>
              {data &&
                Object.keys(data[0].data).map((key) => {
                  return (
                    <Button
                      onClick={() => handleClickPlatForm(key)}
                      outline={platForm === key ? false : true}
                      size="lg"
                      style={{
                        color: platForm === key ? "white" : "#A21C1C",
                        backgroundColor: platForm === key ? "#A21C1C" : "",
                        borderColor: "#A21C1C",
                      }}
                    >
                      {key.toUpperCase()}
                    </Button>
                  );
                })}
            </ButtonGroup>
          </Row>
          {metaData && Object.keys(metaData).map((keyTitle) => (
            <>
              <PageTitle subtitle={capitalizeTitle(keyTitle)} />
              <Row>
                {Object.keys(metaData?.[keyTitle]).map((stats, idx) => (
                  <Col className="col-3 mb-4" key={idx}>
                    <SmallStats
                      id={`small-stats-${idx}`}
                      variation="1"
                      chartData={[
                        {
                          label: "Today",
                          fill: "start",
                          borderWidth: 1.5,
                          backgroundColor: "rgba(0, 184, 216, 0.1)",
                          borderColor: "rgb(0, 184, 216)",
                          data: [1, 3, 4, 3, 5, 4, 5],
                        },
                      ]}
                      chartLabels={[null, null, null, null, null, null, null]}
                      label={capitalizeTitle(stats)}
                      value={metaData?.[keyTitle][stats]}
                    />
                  </Col>
                ))}
              </Row>
            </>))}
        </>
      ) : null}
    </Container>
  );
};

export default BlogOverview;
